
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import useBreakpoints from "@/services/Breakpoints";
import i18n from "@/i18n";
import { firestore } from "@/config/firebase";
export default defineComponent({
  setup() {
    const { type } = useBreakpoints();
    const emitter: any = inject("emitter");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const isHomeView = ref(false);
    const isScroll = ref(false);
    const isOnlineRegisterActive = computed(
      () => store.getters["user/checkIfRegisterOnlineIsEnabled"]
    );
    const optionalOnlineRegisterURL = computed(
      () => store.getters["user/getOptionURLRegister"]
    );
    const profileImage = ref("");
    const toggleSidebar = () => {
      emitter.emit("toogleDrawer", true);
    };
    const isLogged = computed(() => {
      return store.getters["user/isLogged"];
    });
    const data = computed(() => {
      return store.getters["user/data"];
    });
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const participantData = computed(() => {
      return store.getters["user/participantData"];
    });
    const statusPaid = computed(() => {
      const isLogged = store.getters["user/isLogged"];
      if (isLogged) return !store.getters["user/isPaid"];
      return false;
    });
    const signOut = async () => {
      await store.dispatch("user/signOut");
    };
    const getUserProfileImage = async (eventID, participantID) => {
      const userRef = await firestore("events")
        .doc(eventID)
        .collection("participants")
        .doc(participantID)
        .get();
      profileImage.value = userRef.data()?.profileImage;
    };
    const participantPhoto = computed(() => {
      if (participantData.value) {
        getUserProfileImage(eventData.value.id, participantData.value.uid);
        if (profileImage.value) {
          return profileImage.value;
        }
        return require("@/assets/no_profile_image.png");
      }
      return require("@/assets/no_profile_image.png");
    });
    const getEventClass = () => {
      if (eventData.value) {
        if (eventData.value.themeSettings) {
          return {
            "background-color": eventData.value.themeSettings.primaryColor,
            color: eventData.value.themeSettings.contrastColor,
          };
        }
      }
      return {};
    };
    const filterFeatures = (feature) => {
      switch (feature) {
        case "speakers":
          return {
            title: i18n.global.t("drawer.speakers"),
            to: "speakers",
          };
        case "courses_and_program":
          return {
            title: i18n.global.t("drawer.program"),
            to: "Program",
          };
        case "rooming":
          return {
            title: i18n.global.t("drawer.hotelBooking"),
            to: "Hotels",
          };
        case "expo":
          return {
            title: i18n.global.t("drawer.expo"),
            to: "Expo",
          };
        case "abstracts":
          return {
            title: i18n.global.t("drawer.abstracts"),
            to: "Abstracts",
          };
      }
    };
    const eventFeatures = () => {
      if (eventData.value.eventFeatures) {
        const featuresObject = eventData.value.eventFeatures;
        const featuresData: Array<{ title: string; to: string }> = [];
        if (typeof featuresObject === "object") {
          for (const feature of featuresObject) {
            if (
              feature.id === "rooming" ||
              feature.id === "online_registration" ||
              feature.id === "qr_id"
            ) {
              const featureFormat = filterFeatures(feature.id);
              if (featureFormat && feature.isSelected)
                featuresData.push(featureFormat);
            }
          }
          return featuresData;
        }
        return [];
      }
      return [];
    };
    const goTo = (to) => {
      if (typeof to == "string") {
        router.push({
          name: to,
          params: { eventID: eventData.value.id },
        });
      }
    };
    watch(route, () => {
      if (route.name === "Home") isHomeView.value = true;
      else isHomeView.value = false;
    });
    onMounted(() => {
      if (route.name === "Home") isHomeView.value = true;
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    const handleScroll = () => {
      if (window.scrollY > 70) isScroll.value = true;
      else isScroll.value = false;
    };
    const goToOptionalRegister = () => {
      window.open(optionalOnlineRegisterURL.value, "_blank");
    };
    return {
      toggleSidebar,
      eventData,
      isHomeView,
      getEventClass,
      goTo,
      statusPaid,
      isLogged,
      participantPhoto,
      participantData,
      eventFeatures,
      type,
      data,
      signOut,
      isScroll,
      isOnlineRegisterActive,
      optionalOnlineRegisterURL,
      goToOptionalRegister,
    };
  },
});
